import styled from "styled-components";
import BgDotsImg from '../../../images/bg-dots.png'

export const AboutServicesBg = styled.div`
    background-image: url(${BgDotsImg}), linear-gradient(to top right, white, #FDECDF44, #FDECDF44, white, white);
    background-repeat: no-repeat;
    background-position: 0% 40%;
    background-size: auto 100px, auto;
`
